




import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import FrameRenderer, { MessageListenerEvent, Params } from '@/helpers/frame';

@Component
export default class GameFrame extends Vue {
  @Prop({ type: String, required: true })
  readonly link!: string;

  @Prop({ type: Object, default: () => ({}) })
  readonly getParams!: Params;

  @Prop({ type: Object, default: () => ({}) })
  readonly postParams!: Params;

  renderer: FrameRenderer | undefined = undefined;

  @Watch('getParams')
  getParamsChanged() {
    this.renderFrame();
  }

  mounted() {
    this.renderer = new FrameRenderer({
      link: this.link,
      target: this.$el,
      listener: this.handleFrameMessage,
    });

    this.renderFrame();
  }

  renderFrame() {
    if (!this.renderer) {
      throw new Error('Renderer is not initialized');
    }

    this.renderer.render(this.getParams, this.postParams);
  }

  postMessage(code: string, params: Params = {}): void {
    if (!this.renderer) {
      throw new Error('Renderer is not initialized');
    }

    this.renderer.postMessageToFrame({ code, params });
  }

  handleFrameMessage(event: MessageListenerEvent) {
    this.$emit('message', event);
  }
}
